import { ACCT_CONSTANTS as accountConstants } from '../../../constants';
import { CountryCode } from '@app/models/CountryCode';
import { Homeowner } from '@app/models/Homeowner';
import { CountryCallingCodeApi } from '@app/services/apiServices/CountryCallingCodeApi';
import { HomeownerApi } from '@app/services/apiServices/HomeownerApi';
import { NetworkErrorService } from '@app/services/NetworkError.service';
import { UserStore } from '@app/services/stores/UserStore';
import { RegistrationApi } from '@app/services/apiServices/RegistrationApi';
import { ScrollService } from '@app/services/Scroll.service';
import { ErrorHandlerService } from '@app/services/ErrorHandler.service';
import { SpinnerService } from '@app/services/spinner.service';
import { EventType } from '@app/models/EventType';
import { UtilService } from '@app/services/Util.service';
import { LogoutService } from '@app/services/Logout.service';
import { take } from "rxjs/operators";
import { Component, Inject } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { MatDialog } from "@angular/material/dialog";
import { DialogOkayCancelComponent } from "@app/components/sharedDialogs/dialogOkayCancel.component";
import { OneButtonDialogComponent } from "@app/components/sharedDialogs/oneButtonDialog.component";
import { DialogUserNameComponent } from "@app/components/sharedDialogs/dialogUserName.component";
import { AppDataService } from "@app/services/appData.service";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatIconModule } from '@angular/material/icon';
import { PhonePipe } from "@app/pipes/phone-pipe";
import { DOCUMENT } from "@angular/common";

/**
 * Created by mac85103 on 11/28/16.
 */
@Component({
    selector: 'app-account',
    template: require('./account.html')
})
export class AccountComponent {
    email: string;
    firstname: string;
    lastname: string;
    username: any;
    homeownerId: number;
    homeowner: Homeowner;
    uid: string;

    showContent: boolean;
    showSaveCancel: boolean;
    emailAddressExists: boolean;

    countryCode: CountryCode;
    countryCodes: CountryCode[] = [];
    // need this for phone number bug on android.
    phoneElement: any;

    currentPhoneNumber: string;
    currentEmail: string;
    currentFirstName: string;
    currentLastName: string;

    amuiURL: string;
    amuiSecurityURL: string;
    amuiRefURL: string;

    textMessagesEnabled: boolean;
    notifySMSEnabled: boolean;
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
    showPassword = false;

    editingEmail: boolean = false;
    editingName: boolean = false;
    editingPhoneNumber: boolean = false;
    resettingPassword: boolean = false;

    phoneNumberChanged: boolean = false;
    firstNameChanged: boolean = false;
    lastNameChanged: boolean = false;
    emailChanged: boolean = false;
    notifySMSToggleChanged: boolean = false;

    phoneNumberError: boolean;
    countryCodeError: boolean;
    emailAddressError: boolean;
    firstnameError: boolean;
    lastnameError: boolean;
    passwordError: string;
    currentPasswordError: boolean;
    confirmPasswordError: string;
    updatePartyAccountError: boolean = false;
    updateOktaAccountError: boolean = false;

    newPassword1Error: boolean = false;
    confirmFocused: boolean;
    showPasswordInvalidMessage: boolean = false;
    passwordStrength: string = '';
    strengthMeterStyle: string = '';
    strengthTextStyle: string = '';
    passwordsMatch: boolean = true;

    upperCaseCharExists: boolean;
    lowerCaseCharExists: boolean;
    numericCharExists: boolean;
    specialCharExists: boolean;
    invalidCharExists: boolean;
    passwordContainsFirstName: boolean;
    passwordContainsLastName: boolean;
    passwordContainsUsername: boolean;

    emailAddressErrorMessage: string ='';

    hasPasswordInputBlurred: boolean = false;

    readonly ssoResetPasswordMessage =
        'If you entered from your Homeowner Portal and do not have an existing password; please return to the main login screen and select "forgot password" to create one for your profile.';
    isSsoUser: boolean;

    constructor(
        @Inject(WindowToken) private window,
        @Inject(DOCUMENT) private $document: Document,
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(CountryCallingCodeApi) private countryCallingCodeApi: CountryCallingCodeApi,
        @Inject(HomeownerApi) private homeownerApi: HomeownerApi,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(RegistrationApi) private registrationApi: RegistrationApi,
        @Inject(ScrollService) private scrollService: ScrollService,
        @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(UtilService) private utilService: UtilService,
        @Inject(LogoutService) private logoutService: LogoutService,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(UserStore) private userStore: UserStore,
        @Inject(PhonePipe) private phonePipe: PhonePipe,
    ) {
        this.showContent = false;
        this.spinnerService.closeSpinner();
        this.showSaveCancel = false;
        this.textMessagesEnabled = false;

        this.isSsoUser = !!this.userStore.getSsoOrigin();
        this.email = this.userStore.getEmail();
        this.firstname = this.userStore.getFirstName();
        this.lastname = this.userStore.getLastName();
        this.username = this.userStore.getName();
        this.homeownerId = this.userStore.getHoaHomeownerId();
        this.uid = this.userStore.getUid();

        this.amuiURL = this.appDataService.appConfig.get_APP_ENV().AMUI_URL;
        this.amuiRefURL = this.appDataService.appConfig.get_APP_ENV().AMUI_REF_URL;
        this.amuiSecurityURL = this.amuiURL + '#profile:security:';

        this.refreshHomeowner();
    }

    refreshHomeowner() {
        this.homeownerApi.homeownersIdGet(this.homeownerId).pipe(take(1)).subscribe({
            next: data => {
                this.homeowner = data;
                this.notifySMSEnabled = this.homeowner.contactInformation.notifyBySms;
                this.currentPhoneNumber = this.homeowner.contactInformation.phones[0].value = this.homeowner.contactInformation.phones[0].value.replace(/[^0-9]+/g, '');
                this.currentEmail = this.homeowner.contactInformation.email.value;
                this.currentFirstName = this.homeowner.firstName;
                this.currentLastName = this.homeowner.lastName;

                this.getCountryCodes();
                this.showContent = true;
            },
            error: reason => {
                let errMsg: string = undefined;
                if (reason.error && reason.error.message) {
                    errMsg = reason.error.message;
                }
                this.errorHandlerService.handleNetworkError(reason, true, errMsg)
                    .pipe(take(1)).subscribe();
            },
        });
    }

    notifySMSToggle() {
        this.showSaveCancel = true;
        this.notifySMSToggleChanged = !this.notifySMSToggleChanged;
    }

    editPhoneNumber() {
        this.showSaveCancel = true;
        this.editingPhoneNumber = true;
    }

    editEmail() {
        const dialogRef = this.dialog.open(DialogOkayCancelComponent, {
            closeOnNavigation: false,
            disableClose: true,
            data: {
                header: 'Change Email Notification',
                message: 'Changing your email will also change the username you use to login.',
                message2: 'Upon successful completion of the email change, you will be redirected to the home page and required to login with your new email address.'
            }
        })

        dialogRef.afterClosed().pipe(take(1)).subscribe((returnedValue) => {
            if (returnedValue === 'OK') {
                this.homeowner.contactInformation.email.value = "";
                this.showSaveCancel = true;
                this.editingEmail = true;
            }
        })
    }

    editName() {
        this.showSaveCancel = true;
        this.editingName = true;
    }

    resetPassword() {
        // reset the Password Requirements booleans
        this.passwordContainsFirstName = true;
        this.passwordContainsLastName = true;
        this.passwordContainsUsername = true;
        this.lowerCaseCharExists = false;
        this.upperCaseCharExists = false;
        this.numericCharExists = false;
        this.specialCharExists = false;
        this.passwordsMatch = false;

        this.showSaveCancel = true;
        this.resettingPassword = true;
        this.scrollService.scrollTo('resetPasswordSection');
    }

    save() {
        this.spinnerService.showSpinner();

        this.updatePartyAccountError = false;
        this.updateOktaAccountError = false;

        if (this.editingEmail) {
            this.registrationApi.emailValidation(this.homeowner.contactInformation.email.value)
                .pipe(take(1)).subscribe({
                    next: data => {
                        if (data.success) {
                            if (!this.validateEmail(this.homeowner.contactInformation.email.value)) {
                                this.spinnerService.closeSpinner();
                                this.emailAddressErrorMessage = "Please enter a valid email address.";
                            } else {
                                this.emailAddressErrorMessage = "";
                                this.homeownerApi.homeownersIdPostAccountEmail(this.homeowner)
                                    .pipe(take(1)).subscribe({
                                        next: () => {
                                            this.spinnerService.closeSpinner();

                                            this.editingEmail = false;

                                            const dialogRef = this.dialog.open(OneButtonDialogComponent, {
                                                closeOnNavigation: false,
                                                disableClose: true,
                                                data: {
                                                    header: 'Email Change Success',
                                                    message: 'Email changes were saved successfully.',
                                                    message2: 'You will be redirected to the home page and required to login with your new email address.',
                                                    buttonText: 'OK'
                                                }
                                            })

                                            dialogRef.afterClosed()
                                                .pipe(take(1)).subscribe(() => this.logoutService.logout());

                                        }, error: err => {
                                            // catching homeowner-update email
                                            this.spinnerService.closeSpinner();
                                            let errMsg: string = undefined;
                                            if (err.error && err.error.message) {
                                                errMsg = err.error.message;
                                            }
                                            this.errorHandlerService.handleNetworkError(err, true, errMsg)
                                                .pipe(take(1)).subscribe();
                                        }
                                    });
                            }
                        } else {
                            this.spinnerService.closeSpinner();
                            this.emailAddressErrorMessage = "Please enter a valid email address.";
                        }
                    },
                    error: err => {
                        this.spinnerService.closeSpinner();
                        let errMsg: string = undefined;
                        if (err.error && err.error.message) {
                            errMsg = err.error.message;
                        }
                        this.errorHandlerService.handleNetworkError(err, true, errMsg)
                            .pipe(take(1)).subscribe();
                    }
                });
        }
        else if (!this.resettingPassword) {

            this.homeownerApi.homeownersIdGet(this.homeownerId)
                .pipe(take(1)).subscribe({
                    next: data => {
                        const homeowner = data;
                        const phoneNumber = this.homeowner.contactInformation.phones[0].value;
                        const notifySms = this.notifySMSEnabled;

                        homeowner.firstName = this.homeowner.firstName;
                        homeowner.lastName = this.homeowner.lastName;
                        homeowner.contactInformation.amuiId = this.homeowner.contactInformation.email.value;
                        homeowner.contactInformation.email.value = this.homeowner.contactInformation.email.value;
                        homeowner.contactInformation.phones[0].countryCallingCode = this.countryCode.country;
                        homeowner.contactInformation.phones[0].value = String(phoneNumber).replace(/\D/g, '');
                        homeowner.contactInformation.notifyBySms = notifySms;
                        homeowner.contactInformation.amuiId = this.uid;

                        JSON.stringify(homeowner, null, 2);

                        this.homeownerApi.homeownersIdPostAccount(homeowner)
                            .pipe(take(1)).subscribe({
                                next: partyUpdatedHomeownerResp => {
                                    this.homeownerApi.userPost(partyUpdatedHomeownerResp, this.username)
                                        .pipe(take(1)).subscribe({
                                            next: oktaUpdatedHomeowner => {
                                                this.homeownerApi.homeownersSendNotificationPost(oktaUpdatedHomeowner, EventType.ACCOUNT_UPDATE)
                                                    .pipe(take(1)).subscribe({
                                                        next: () => {
                                                            this.editingName = false;
                                                            this.editingPhoneNumber = false;
                                                            this.showSaveCancel = false;
                                                            this.spinnerService.closeSpinner();

                                                            const dialogRef = this.dialog.open(OneButtonDialogComponent, {
                                                                closeOnNavigation: false,
                                                                disableClose: true,
                                                                data: {
                                                                    header: 'Account Change Success',
                                                                    message: 'Account changes were saved successfully.',
                                                                    message2: 'This page will refresh as your account information is updated.',
                                                                    buttonText: 'OK'
                                                                }
                                                            })

                                                            dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
                                                                this.spinnerService.showSpinner();
                                                                sessionStorage.setItem('hoapay_savedLocation', window.location.href);
                                                                this.window.location.replace(this.appDataService.appConfig.get_APP_ENV().OAUTH_AUTHENTICATE_URL);
                                                            });

                                                        },
                                                        error: err => {
                                                            // catching homeowner-notification
                                                            this.spinnerService.closeSpinner();
                                                            let errMsg: string = undefined;
                                                            if (err.error && err.error.message) {
                                                                errMsg = err.error.message;
                                                            }
                                                            this.errorHandlerService.handleNetworkError(err, true, errMsg)
                                                                .pipe(take(1)).subscribe();
                                                        }
                                                    })
                                            }, error: err => {
                                                // catching okta-post
                                                this.spinnerService.closeSpinner();
                                                let errMsg: string = undefined;
                                                if (err.error && err.error.message) {
                                                    errMsg = err.error.message;
                                                }
                                                this.errorHandlerService.handleNetworkError(err, true, errMsg)
                                                    .pipe(take(1)).subscribe();
                                            }
                                        })
                                },
                                error: err => {
                                // catching homeowner-post
                                    this.spinnerService.closeSpinner();
                                    let errMsg: string = undefined;
                                    if (err.error && err.error.message) {
                                        errMsg = err.error.message;
                                    }
                                    this.errorHandlerService.handleNetworkError(err, true, errMsg)
                                        .pipe(take(1)).subscribe();
                                }
                            })
                    },
                    error: err => {
                        // catching homeowner-get
                        this.spinnerService.closeSpinner();
                        let errMsg: string = undefined;
                        if (err.error && err.error.message) {
                            errMsg = err.error.message;
                        }
                        this.errorHandlerService.handleNetworkError(err, true, errMsg)
                            .pipe(take(1)).subscribe();
                    }
                });

        } else {
            this.homeownerApi.userResetPasswordPost(this.homeowner, this.currentPassword, this.newPassword)
                .pipe(take(1)).subscribe({
                    next: userResetPasswordHomeownerResp => {
                        this.homeownerApi.homeownersSendNotificationPost(userResetPasswordHomeownerResp, EventType.PASSWORD_RESET)
                            .pipe(take(1)).subscribe({
                                next: () => {
                                    this.spinnerService.closeSpinner();
                                    this.showSaveCancel = false;
                                    this.resettingPassword = false;
                                    this.currentPassword = null;
                                    this.newPassword = null;
                                    this.confirmPassword = null;
                                    this.showPassword = false;

                                    this.dialog.open(OneButtonDialogComponent, {
                                        closeOnNavigation: false,
                                        disableClose: true,
                                        data: {
                                            header: 'Reset Password Successful.',
                                            message: 'Password has been reset successfully and will be in effect the next time you login.',
                                            buttonText: 'OK'
                                        }
                                    })
                                },
                                error: err => {
                                    this.spinnerService.closeSpinner();
                                    let errMsg: string = undefined;
                                    if (err.error && err.error.message) {
                                        errMsg = err.error.message;
                                    }
                                    this.errorHandlerService.handleNetworkError(err, true, errMsg)
                                        .pipe(take(1)).subscribe();
                                }
                            })
                    },
                    error: err => {
                        this.spinnerService.closeSpinner();
                        this.updatePartyAccountError = true;
                        let errMsg: string = undefined;
                        if (err.error && err.error.message) {
                            errMsg = err.error.message;
                        }
                        this.errorHandlerService.handleNetworkError(err, true, errMsg)
                            .pipe(take(1)).subscribe();
                    }
                });
        }
    }

    cancel() {
        if (this.notifySMSToggleChanged) {
            this.notifySMSToggle();
        }

        if (this.shouldResetPhoneNumber(this.homeowner.contactInformation.phones[0].value)) {
            this.homeowner.contactInformation.phones[0].value = this.currentPhoneNumber;
            this.formatPhoneNumber();
        }

        if (this.shouldResetEmail(this.homeowner.contactInformation.email.value)) {
            this.homeowner.contactInformation.email.value = this.currentEmail;
            this.emailChanged = false;
            this.emailAddressError = false;
        }

        if (this.shouldResetFirstname(this.homeowner.firstName)) {
            this.homeowner.firstName = this.currentFirstName;
            this.firstNameChanged = false;
            this.firstnameError = false;
        }

        if (this.shouldResetLastname(this.homeowner.lastName)) {
            this.homeowner.lastName = this.currentLastName;
            this.lastNameChanged = false;
            this.lastnameError = false;
        }

        this.editingPhoneNumber = false;
        this.editingEmail = false;
        this.editingName = false;
        this.showSaveCancel = false;
        this.resettingPassword = false;

        this.currentPassword = null;
        this.newPassword = null;
        this.confirmPassword = null;
    }

    usernameHelper() {
        this.dialog.open(DialogUserNameComponent, {
            closeOnNavigation: false,
            disableClose: true,
        })
    }

    checkFirstname() {
        if (this.homeowner && this.homeowner.firstName) {
            this.firstNameChanged = true;
            this.firstnameError = false;
        } else {
            this.firstnameError = true;
        }
    }

    checkLastname() {
        if (this.homeowner && this.homeowner.lastName) {
            this.lastNameChanged = true;
            this.lastnameError = false;
        } else {
            this.lastnameError = true;
        }
    }

    checkCurrentPassword() {
        this.currentPasswordError = !(this.currentPassword && this.currentPassword.length > 0);
    }

    checkPhoneNumberLength() {
        // make sure that homeowner.contactinformation.phones[0].value exists, the hard way.
        if (this.homeowner && this.homeowner.contactInformation && this.homeowner.contactInformation.phones && this.homeowner.contactInformation.phones[0].value) {
            if (this.homeowner.contactInformation.phones[0].value.replace(/[^0-9]+/g, '').length < 10 && (this.countryCode.country === 'USA' || this.countryCode.country === 'CAN')) {
                this.phoneNumberError = true;
            } else {
                this.phoneNumberChanged = true;
                this.phoneNumberError = this.homeowner.contactInformation.phones[0].value.replace(/[^0-9]+/g, '').length < 4;
            }
        } else {
            this.phoneNumberError = true;
        }
    }

    getCountryCodes() {
        this.countryCallingCodeApi.getAllCountries(true)
            .pipe(take(1)).subscribe((data) => {
                this.countryCodes = data.data;
                const phone0 = this.homeowner.contactInformation.phones[0];
                this.countryCode = this.countryCodes.filter(x => x.country === (phone0.countryCallingCode ? phone0.countryCallingCode : 'USA'))[0]; //default to USA
                this.formatPhoneNumber();
            });
    }

    onCountryCodeChange(event: any) {
        this.countryCode = this.countryCodes[event.target.selectedIndex];
        this.formatPhoneNumber();
        try {
            // set the country code for the homeowner object
            this.homeowner.contactInformation.phones[0].countryCallingCode = this.countryCode.country;
        } catch (_dne) {
        }
    }

    formatPhoneNumber() {

        if (!this.phoneElement) {
            this.phoneElement = this.$document.querySelector('#input-text-phone-number');
        }

        const phone0 = this.homeowner.contactInformation.phones[0];
        if ((phone0.value == null || phone0.value === '') && !this.phoneNumberChanged) {
            this.phoneNumberError = false;
        } else {
            this.phoneNumberChanged = true;
            this.phoneNumberError = !phone0.countryCallingCode;
            // set the country code on homeowner object
            phone0.countryCallingCode = this.countryCode.code;
            // make sure that homeowner.contactinformation.phones[0].value exists, the hard way.
            if (phone0.value) {
                this.phoneNumberChanged = true;
                let formattedPhoneNumber: string;
                let value: string = phone0.value;
                if (this.countryCode.country === 'USA' || this.countryCode.country === 'CAN') {
                    this.phoneNumberError = false;
                    value = value.replace(/[^0-9]/g, '');
                    if (value[0] === '0' || value[0] === '1') {
                        value = value.slice(1);
                    }
                    formattedPhoneNumber =  this.phonePipe.transform(value);
                } else {
                    const countryCodeValue = this.countryCode.value || '';
                    formattedPhoneNumber = value.replace(/[^0-9]+/g, '')
                        .substring(0, 15 - countryCodeValue.length);
                }
                if (phone0.value !== formattedPhoneNumber) {
                    phone0.value = formattedPhoneNumber;
                }
                if (this.phoneElement && this.phoneElement[0]) this.phoneElement[0].value = formattedPhoneNumber;
            }
            // force cursor to be at the end of phone number input all the time. We should only see a max of 14 characters or so, 99 is safe.
            if (this.phoneElement && this.phoneElement[0]) this.phoneElement[0].setSelectionRange(99, 99);
        }
    }

    shouldResetPhoneNumber(phoneNumber: string): boolean {
        return (
            phoneNumber === undefined ||
            phoneNumber === '' ||
            phoneNumber == null ||
            this.phoneNumberChanged ||
            this.currentPhoneNumber !== phoneNumber.replace(/[^0-9]+/g, '')
        );
    }

    shouldResetEmail(email: string): boolean {
        return (
            email === undefined ||
            email === '' ||
            email == null ||
            this.emailChanged ||
            this.currentEmail !== email
        );
    }

    shouldResetFirstname(firstname: string): boolean {
        return (
            firstname === undefined ||
            firstname === '' ||
            firstname == null ||
            this.firstNameChanged ||
            this.currentFirstName !== firstname
        );
    }

    shouldResetLastname(lastname: string): boolean {
        return (
            lastname === undefined ||
            lastname === '' ||
            lastname == null ||
            this.lastNameChanged ||
            this.currentLastName !== lastname
        );
    }

    invalid(): boolean {
        return this.countryCodeError || this.phoneNumberError || this.emailAddressError || this.emailAddressExists || this.firstnameError
            || this.lastnameError || this.showPasswordInvalidMessage || this.currentPasswordError || !this.passwordsMatch;
    }

    analyzePassword() {
        // Get password strength
        this.setProgressClass(this.getPasswordStrength(this.newPassword));

        if (this.newPassword && this.confirmPassword === null) {
            // do not show invalid message if password is empty
            this.showPasswordInvalidMessage = false;
        } else {
            // Password validation
            this.showPasswordInvalidMessage = !this.isValidPassword(this.newPassword, this.confirmPassword, this.homeowner.contactInformation.email.value);
        }

    }

    password() {
        if (this.newPassword === null)
            this.passwordError = 'Please enter your password';
        else
            this.passwordError = null;
    }

    setProgressClass(strength) {
        // Make sure all of the styles are removed
        this.strengthMeterStyle = 'HOA-progress-state-invalid';
        this.strengthTextStyle = '';

        // apply style based on passwordStrength
        if ('Too Short' === strength) {
            this.strengthTextStyle = 'u-fontRed';
            this.strengthMeterStyle = 'HOA-progress-state-too-short';
        } else if ('Weak' === strength) {
            this.strengthTextStyle = 'u-fontRed';
            this.strengthMeterStyle = 'HOA-progress-state-weak';
        } else if ('Fair' === strength) {
            this.strengthTextStyle = 'u-fontOrange';
            this.strengthMeterStyle = 'HOA-progress-state-fair';
        } else if ('Good' === strength) {
            this.strengthTextStyle = 'u-fontLime';
            this.strengthMeterStyle = 'HOA-progress-state-good';
        } else if ('Strong' === strength) {
            this.strengthTextStyle = 'fontLimeDarker';
            this.strengthMeterStyle = 'HOA-progress-state-strong';
        } else if ('Strength' === strength) {
            this.strengthTextStyle = 'empty';
            this.strengthMeterStyle = 'HOA-progress-state-empty';
        } else if ('Invalid Character' === strength) {
            this.strengthTextStyle = 'invalidchar';
            this.strengthMeterStyle = 'HOA-progress-state-invalid';
        }

        this.passwordStrength = strength;
    }

    getPasswordStrength(password) {
        /*
         * Length: > 8 characters. Composition: Allowed characters: Aa-Zz, 0-9, -, (_), /, (), (@), ($), !, (#) passsword cannot
         * equal or contain the userId. minimum of two character classes (lower-alpha, upper-alpha, numeric, special character).
         */

        let strength = null;

        if (password === null || password === undefined || password.length < 1) {
            strength = 'Empty';
            this.upperCaseCharExists = false;
            this.lowerCaseCharExists = false;
            this.numericCharExists = false;
            this.specialCharExists = false;
            this.invalidCharExists = false;
        }

        if (strength === null) {
            // get Character classes
            this.upperCaseCharExists = false;
            this.lowerCaseCharExists = false;
            this.numericCharExists = false;
            this.specialCharExists = false;
            this.invalidCharExists = false;

            for (var x = 0; x < password.length; x++) {
                if (password.charAt(x) >= 'A' && password.charAt(x) <= 'Z') {
                    this.upperCaseCharExists = true;
                } else if (password.charAt(x) >= 'a' && password.charAt(x) <= 'z') {
                    this.lowerCaseCharExists = true;
                } else if (password.charAt(x) >= '0' && password.charAt(x) <= '9') {
                    this.numericCharExists = true;
                } else if (password.charAt(x) === '-' || password.charAt(x) === '_' || password.charAt(x) === '/'
                    || password.charAt(x) === '@' || password.charAt(x) === '$'
                    || password.charAt(x) === '#' || password.charAt(x) === '!') {
                    this.specialCharExists = true;
                } else {
                    this.invalidCharExists = true;
                }
            }

            var strengthVal = 0;
            if (this.upperCaseCharExists) {
                strengthVal++;
            }
            if (this.lowerCaseCharExists) {
                strengthVal++;
            }
            if (this.numericCharExists) {
                strengthVal++;
            }
            if (this.specialCharExists) {
                strengthVal++;
            }
            if (password.length >= 13) {
                strengthVal++;
            }

            if (this.invalidCharExists) {
                strength = 'Invalid Character';
            } else if (password.length < 13) {
                strength = 'Too Short';
            } else if (strengthVal <= 2) {
                strength = 'Weak';
            } else if (strengthVal === 3) {
                strength = 'Fair';
            } else if (strengthVal === 4) {
                strength = 'Good';
            } else {
                // Strength is 5 or greater
                strength = 'Strong';
            }
        }
        this.passwordStrength = strength;
        return strength;
    }

    isValidPassword(password, confirmPassword, userId) {
        return this.getInvalidPasswordMsg(password, confirmPassword, userId).length === 0;
    }

    getInvalidPasswordMsg(password, confirmPassword, userId) {
        let invalidPasswordMsg = ''; // NOSONAR: This isn't a password...

        if (password !== confirmPassword) {
            this.passwordsMatch = false;
        } else if (password === confirmPassword) {
            this.passwordsMatch = true;
        }

        if (this.isEmpty(password) || (confirmPassword && this.isEmpty(confirmPassword))) {
            return accountConstants().FILL_IN_ALL_FIELDS;
        } else if (!this.isValidPasswordNoConfirm(password, userId)) {
            return this.getInitialInvalidPasswordMsg(password, userId);
        }

        return invalidPasswordMsg;
    }

    isEmpty(value) {
        return !(value && value.length > 0);

    }

    isValidPasswordNoConfirm(password, userId) {
        return this.getInitialInvalidPasswordMsg(password, userId).length === 0;
    }

    getInitialInvalidPasswordMsg(password, userId) {
        /*
         * Length: > 13 characters. Composition: Allowed characters: Aa-Zz, 0-9, -, (_), /, (), (@), ($), !, (#) passsword cannot
         * equal or contain the userId. minimum of two character classes (lower-alpha, upper-alpha, numeric, special character).
         *
         * Enterprise LDAP web service will not allow any argument with a wildcard (defined as '*'), so '*' effectively are
         * prohibited from user passwords.
         */
        let invalidPasswordMsg = ''; // NOSONAR: This isn't a password...
        if (password && password.length < 13 && password.length !== 0) {
            invalidPasswordMsg = accountConstants().PW_INVALID_TOO_SHORT;
        }

        // okta - cannot contain first name
        this.passwordContainsFirstName = false;
        if (this.utilService.hasName(password, this.homeowner.firstName)) {
            this.passwordContainsFirstName = true;
            invalidPasswordMsg = accountConstants().PW_INVALID_CONTAINS_FIRST_NAME;
        }

        // okta - cannot contain last name
        this.passwordContainsLastName = false;
        if (this.utilService.hasName(password, this.homeowner.lastName)) {
            this.passwordContainsLastName = true;
            invalidPasswordMsg = accountConstants().PW_INVALID_CONTAINS_LAST_NAME;
        }

        // okta - cannot contain part of username
        this.passwordContainsUsername = this.utilService.hasPartOfEmail(password, userId);
        // validate invalidPasswordMsg - could've been set during char by char check above
        if (this.passwordContainsUsername) {
            invalidPasswordMsg = accountConstants().PW_INVALID_CONTAINS_USER_NAME;
        }

        if (invalidPasswordMsg.length === 0) {
            // get Character classes
            this.upperCaseCharExists = false;
            this.lowerCaseCharExists = false;
            this.numericCharExists = false;
            this.specialCharExists = false;
            this.invalidCharExists = false;

            for (var x = 0; x < password.length; x++) {
                if (password.charAt(x) >= 'A' && password.charAt(x) <= 'Z') {
                    this.upperCaseCharExists = true;
                } else if (password.charAt(x) >= 'a' && password.charAt(x) <= 'z') {
                    this.lowerCaseCharExists = true;
                } else if (password.charAt(x) >= '0' && password.charAt(x) <= '9') {
                    this.numericCharExists = true;
                } else if (password.charAt(x) === '-' || password.charAt(x) === '_' || password.charAt(x) === '/'
                    || password.charAt(x) === '@' || password.charAt(x) === '$' || password.charAt(x) === '#'
                    || password.charAt(x) === '!') {
                    this.specialCharExists = true;
                } else {
                    this.invalidCharExists = true;
                    // Don't need to check the rest of the password at this point
                    // break;
                }
            }
            var charClassCount = 0;
            if (this.upperCaseCharExists) {
                charClassCount++;
            }
            if (this.lowerCaseCharExists) {
                charClassCount++;
            }
            if (this.numericCharExists) {
                charClassCount++;
            }
            if (this.specialCharExists) {
                charClassCount++;
            }
            if (this.invalidCharExists) {
                invalidPasswordMsg = accountConstants().PW_INVALID_CHARACTERS;
            } else if (charClassCount < 4 && password.length !== 0) {
                invalidPasswordMsg = accountConstants().PW_INVALID_ONE_CHAR_CLASS;
            }
        }

        if (invalidPasswordMsg.length === 0) {
            return '';
        } else {
            return invalidPasswordMsg;
        }
    }

    confirmPasswordCheck() {
        this.confirmFocused = true;
        this.passwordsMatch = true;
        this.confirmPasswordError = null;

        if (this.confirmPassword === null)
            this.confirmPasswordError = 'Please confirm your password';
        else if (this.confirmPassword != this.newPassword) {
            this.confirmPasswordError = "Passwords do not match"
            this.passwordsMatch = false;
        }
    }

    onValidateEmail() {
        if (!this.validateEmail(this.homeowner.contactInformation.email.value)) {
            this.emailAddressErrorMessage = "Please enter a valid email address.";
            this.emailAddressError = true;
        } else {
            this.emailAddressErrorMessage = "";
            this.emailAddressError = false;
        }
    }

    validateEmail(email) {
        if (email != null && email.length > 0) {
            const regex = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/;

            return regex.test(email);
        }
        return true;
    }

    onSubmit() {
        return false;
    }

    onShowPasswordChange() {
        this.showPassword = !this.showPassword;
    }
}

